import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Listing } from '../../../classes/listing';
import { PreferencesService } from '../../../services/preferences.service';
import { DeviceService } from '../../../services/device/device.service';
import { ADD_SAVED_LISTING_PAGE_GTM } from '../../../classes/analytics-tags';
import { SCREEN_SIZE } from '../../../classes/enums';
import { victoriaRealEstate, caraBoardPartialName, BritishColumbiaStateShort } from '../../../app-config.constants';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment-wrapper';
@Component({
  selector: 'app-listing-summary',
  templateUrl: './listing-summary.component.html',
  // styleUrls: ['./listing-summary.component.scss']
})
export class ListingSummaryComponent implements OnInit, OnChanges {
  @Input() readonly listing: Listing = new Listing();
  @Input() readonly mortgagePaymentAmount: string = '$0';
  @Input() readonly hasNextListings: boolean = false;
  @Input() readonly hasCopiedText: boolean = false;
  @Input() readonly backToText: string;
  @Input() readonly showExpandedGalleryView: boolean = false;
  @Input() readonly showMap: boolean = false;
  @Input() readonly isMortgageApplicable: boolean = false;
  @Input() readonly screenSize: SCREEN_SIZE;
  @Input() readonly isBrowserMode: boolean;
  @Input() readonly isEdmontonBoard: boolean = false;
  @Input() disableSellersLeadForm: boolean;
  @Input() sessionEmail: string = '';
  showRequestSent = false;
  SCREEN_SIZE = SCREEN_SIZE;
  BritishColumbiaStateShort = BritishColumbiaStateShort;
  disabled: boolean = false;
  backButton: string;
  email: string;
  readonly cdnUrl = environment.cdnServerUrl;
  isDropdownOpen = false;
  showEmailModal = false;
  @Output() previousListingClicked: EventEmitter<any> = new EventEmitter();
  @Output() nextListingClicked: EventEmitter<any> = new EventEmitter();
  @Output() showContactAgentClicked: EventEmitter<any> = new EventEmitter();
  @Output() showScheduleViewingClicked: EventEmitter<any> = new EventEmitter();
  @Output() goBack: EventEmitter<any> = new EventEmitter();
  @Output() toggleExpandedGalleryView: EventEmitter<boolean> = new EventEmitter();
  @Output() homeEstimateLinkClick: EventEmitter<any> = new EventEmitter();
  @Output() showOffmarketCTAClicked: EventEmitter<any> = new EventEmitter();
  @Output() toggleMap: EventEmitter<any> = new EventEmitter();
  @ViewChild('imageContainer') imageContainer: ElementRef;


  currentSlideIndex: number = 0; // Which index the carousel should start with, we need this to keep the expanded gallery view and the normal carousel in sync
  isVictoriaRealEstateBoard: boolean = false;
  isCaraBoard: boolean = false;

  constructor(
    private _preferencesService: PreferencesService,
    private deviceService: DeviceService,
    private _router: Router
  ) { }

  ngOnInit() {
    this.backButton = this.listing.isLuxury ? '/assets/icons/general_navigation/Back_to_search_white.svg' : '/assets/icons/general_navigation/Back_to_search_blue.svg';
    this.isVictoriaRealEstateBoard = this.listing.boardName && this.listing.boardName.toLowerCase().indexOf(victoriaRealEstate) !== -1 && !this.listing.isRemaxListing;
    this.isCaraBoard = this.listing.boardName && this.listing.boardName.toLowerCase().indexOf(caraBoardPartialName) !== -1; //&& !this.listing.isRemaxListing;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.listing) {
      this.currentSlideIndex = 0;
    }


  }

  openPrintListingPage() {
    this.isDropdownOpen = false;
    // this._router.navigate([]).then(
    //   result => {
        window.open('/print-listing/' + this.listing.listingId, '_blank');
     // }
    //);
  }

  changeCarouselIndex(event) {
    this.currentSlideIndex = event;
    if (this.imageContainer && !this.deviceService.isSafariBrowser()) {
      this.imageContainer.nativeElement.children[event].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  }

  toggleFavourite($event) {
    this.isDropdownOpen = false;
    $event.stopPropagation();

    this.listing.isFavourite = !this.listing.isFavourite;
    this._preferencesService.toggleFavouriteListing(this.listing.listingId, ADD_SAVED_LISTING_PAGE_GTM);
    this.listing.getFavouriteIconToUse();
  }

  toggleImage(imageIndex) {
    this.currentSlideIndex = imageIndex;
    if (this.showMap && this.listing && this.listing.isLuxury) {
      this.toggleMap.emit();
    }
  }

}

@Component({
  selector: 'app-listing-summary-desktop',
  templateUrl: './listing-summary.desktop.component.html',
  styleUrls: ['./listing-summary.scss', './listing-summary.desktop.component.scss']
})
export class ListingSummaryDesktopComponent extends ListingSummaryComponent implements OnChanges {

  navigateToForm() {
    this.toggleExpandedGalleryView.emit(false);
    if (this.listing.isLuxury) {
      this.showContactAgentClicked.emit();
    } else {
      // TODO: make this smooth
      const top = document.getElementById('contact-form').offsetTop;
      // TODO: make the first input focused on the contact form
      document.getElementById('contact-form').scrollIntoView(true);
    }
  }
}

@Component({
  selector: 'app-listing-summary-mobile',
  templateUrl: './listing-summary.mobile.component.html',
  styleUrls: ['./listing-summary.scss', './listing-summary.mobile.component.scss']
})
export class ListingSummaryMobileComponent extends ListingSummaryComponent {
}
